export default "__VITE_ASSET__3c9ae9e0__"